import { v4 as uuidv4 } from 'uuid'

import Trend from 'pared/pages/ExpoAi/Trend'
import { FROM_EXPO } from 'pared/pages/ExpoAi/constants'
import { IMessage } from 'pared/pages/ExpoAi/type'

export default function handleSalesmanshipKpiTrends(responseData: any) {
  if (responseData?.salesmanshipKpiTrends) {
    const answerMessage: IMessage = {
      id: uuidv4(),
      from: FROM_EXPO,
      content: <Trend data={responseData?.salesmanshipKpiTrends} />,
    }

    return answerMessage
  }

  return null
}
